import React from "react";
import { GeoJSON, Tooltip } from "react-leaflet";

const OVERLAY_COLOR = "#fb8c00";

const style = {
  color: OVERLAY_COLOR,
  weight: 3,
  fillColor: OVERLAY_COLOR,
  fillOpacity: 0.30
};

const onEachFeature = (feature, layer) => {
  layer.on({
    mouseover: (e) => {
      e.target.setStyle({ weight: 4, fillOpacity: 0.5 });
    },
    mouseout: (e) => {
      e.target.setStyle(style);
    }
  });
};

const OverlayGeoJSON = ({ geom, detalhe }) => {
  const hasTooltip =
    detalhe.ref_bacen_efetivo ||
    detalhe.nome_if ||
    detalhe.produto_bacen ||
    detalhe.area_ha_intersecao ||
    detalhe.percentual_intersecao;

  return (
    <GeoJSON
      data={geom}
      style={style}
      onEachFeature={onEachFeature}
    >
      {hasTooltip && (
        <Tooltip sticky>
          <div>
            {detalhe.ref_bacen_efetivo && (
              <p><b>Ref. BACEN:</b> {detalhe.ref_bacen_efetivo}</p>
            )}
            {detalhe.nome_if && (
              <p><b>Inst. Financeira:</b> {detalhe.nome_if}</p>
            )}
            {detalhe.produto_bacen && (
              <p><b>Produto:</b> {detalhe.produto_bacen}</p>
            )}
            {detalhe.area_ha_intersecao && (
              <p><b>Área interseção:</b> {detalhe.area_ha_intersecao} ha</p>
            )}
            {detalhe.percentual_intersecao && (
              <p><b>% interseção:</b> {detalhe.percentual_intersecao}%</p>
            )}
          </div>
        </Tooltip>
      )}
    </GeoJSON>
  );
};

export default OverlayGeoJSON;